import React, { useEffect, useState } from 'react';
import { FormControl, Select, MenuItem, SelectChangeEvent, useTheme, Typography, InputLabel, Box } from '@mui/material';
import useResponsive from '../../hooks/useResponsive';
import { useTranslation } from 'react-i18next';
import { Project } from '../../interfaces/TaskOverview'
import { ProjectItem, useTimerContext } from '../../contexts/TimerContext';

interface ProjectDropdownLogProps {
    projectList: Project[];
    handleProjectChange: (event: SelectChangeEvent<string>) => void;
    isDisabled?: boolean;
    isAnotherProject?: boolean;
}

const ProjectDropdownLog: React.FC<ProjectDropdownLogProps> = ({
    projectList,
    handleProjectChange,
    isDisabled = false,
    isAnotherProject = false
}) => {
    const theme = useTheme();
    const { isMobile, isTablet, isDesktop } = useResponsive();
    const { t } = useTranslation();
    const {
        selectedProjectForLog,
        selectedProjectIdForNavigation,
        isTimerOn
    } = useTimerContext();
    const [selectedProject, setSelectedProject] = useState<ProjectItem | null>({ id: 1, name: "Selecteer project" });
    const iconColor = theme.palette.dropdownHighlight.main;
    const textColor = theme.palette.dropdownHighlight.contrastText;

    const getSelectedProjectWithId = () => {
        const item = projectList.filter((item) => item.id === selectedProjectIdForNavigation)
        console.log("item", item)
        if (item.length) {
            const selectedItem = item[0]
            setSelectedProject({ id: selectedItem.id, name: selectedItem.project_name })
        }
    }

    useEffect(() => {
        if (isAnotherProject) {
            getSelectedProjectWithId()
        } else {
            if (selectedProjectForLog.id) {
                setSelectedProject(selectedProjectForLog)
            } else {
                getSelectedProjectWithId()
            }
        }
    }, [projectList]);

    const handleDropdownChange = async (event: SelectChangeEvent<string>) => {
        const selectedProject = JSON.parse(event.target.value);
        setSelectedProject(selectedProject)
        handleProjectChange(event)
    }
    return (
        <Box sx={{
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center',
            width: isMobile ? '100%' : null
        }}>
            <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Selecteer project</InputLabel>
                <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={selectedProject ? JSON.stringify(selectedProject) : undefined}
                    label="Selecteer project"
                    fullWidth={isMobile && true}
                    disabled={isDisabled || isTimerOn}
                    onChange={handleDropdownChange}
                    renderValue={(selected) => {
                        if (!selected) {
                            return <em style={{ color: 'rgba(0, 0, 0, 0.6)' }}>{t("taskOverViewScreen.pleaseSelectTheProject")}</em>;
                        }
                        const selectedProject = JSON.parse(selected as string);
                        return selectedProject.name;
                    }}
                    sx={{
                        backgroundColor: theme.palette.secondary.main,
                        color: '#2B2A5C',
                        width: isTablet || isDesktop ? 345 : '100%',
                        maxWidth: isTablet || isDesktop ? 345 : '100%',
                        height: isMobile ? 45 : 55,
                        fontFamily: isMobile ? "Nunito Sans Regular400" : (isTablet ? 'Nunito Sans Regular500' : 'Nunito Sans Regular400'),
                        fontSize: isMobile ? '14px' : (isTablet ? '16px' : '18px'),
                        lineHeight: isMobile ? '24px' : (isTablet ? '24px' : '24px'),
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        paddingRight: '28px',
                    }}
                >
                    {projectList.map((project: Project) => (
                        <MenuItem
                            key={project?.id || project?.project_name}
                            value={JSON.stringify({
                                id: project?.id,
                                name: project?.project_name,
                            })}
                            sx={{
                                '&.Mui-selected': {
                                    backgroundColor: iconColor,
                                    color: textColor,
                                },
                                '&.Mui-selected:hover': {
                                    color: '#2B2A5C',
                                },
                                fontFamily: isMobile ? "Nunito Sans Regular400" : (isTablet ? 'Nunito Sans Regular500' : 'Nunito Sans Regular400'),
                                fontSize: isMobile ? '14px' : (isTablet ? '16px' : '18px'),
                                lineHeight: isMobile ? '24px' : (isTablet ? '24px' : '24px'),
                                color: '#2B2A5C',
                                alignItems: 'center',
                            }}
                        >
                            <Typography
                                noWrap
                                sx={{
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap',
                                    maxWidth: '100%',
                                    wordBreak: 'break-all',
                                }}
                            >
                                {project?.project_name}
                            </Typography>
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        </Box>
    );
};

export default ProjectDropdownLog;